import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Search } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";

const RESOURCE_ROUTES = {
  businesses: (i) => `/empresa/${i.id}`,
  services: (i) => `/servico/${i.id}`,
  products: (i) => (i.business_id ? `/empresa/${i.business_id}` : "#"),
  promotions: (i) => (i.business_id ? `/empresa/${i.business_id}` : "#"),
  coupons: (i) => (i.business_id ? `/empresa/${i.business_id}` : "/#coupons"),
  news: (i) => `/noticia/${i.id}`,
  events: (i) => `/evento/${i.id}`,
  tourist_spots: (i) => `/ponto-turistico/${i.id}`,
  jobs: () => "/#jobs",
  rentals: () => "/#rentals",
  commercial_spots: () => "/#commercial_spots",
  categories: (i) => `/empresas?categoria=${encodeURIComponent(i.name)}`,
};

const LABELS = {
  businesses: "Empresa", services: "Serviço", products: "Produto", promotions: "Promoção", coupons: "Cupom",
  news: "Notícia", events: "Evento", tourist_spots: "Ponto Turístico", jobs: "Vaga",
  rentals: "Imóvel", commercial_spots: "Ponto Comercial", categories: "Categoria",
};

const title = (r, i) => i.name || i.title || i.code || "";

const SearchPage = () => {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get(`/public/search/all?q=${encodeURIComponent(q)}`)
      .then((r) => setResults(r.data.results))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <SiteLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex items-center gap-2 text-muted-foreground mb-4">
          <Search className="w-5 h-5" />
          <h1 className="text-lg font-bold font-heading text-foreground">Resultados para "{q}"</h1>
        </div>
        {loading ? (
          <p className="text-muted-foreground">Buscando...</p>
        ) : results.length === 0 ? (
          <p className="text-muted-foreground py-10 text-center">Nada encontrado. Tente outra palavra.</p>
        ) : (
          <div className="space-y-2">
            {results.map(({ resource, item }, idx) => (
              <Link
                key={`${resource}-${item.id || idx}`}
                to={RESOURCE_ROUTES[resource]?.(item) || "#"}
                data-testid={`search-result-${idx}`}
                className="flex items-center gap-3 bg-card rounded-2xl border border-border p-3 hover:border-primary transition-colors"
              >
                {(item.cover || item.image || item.logo || (item.photos && item.photos[0])) && (
                  <img src={fileUrl(item.cover || item.image || item.logo || item.photos[0])} alt="" className="w-14 h-14 rounded-xl object-cover shrink-0" />
                )}
                <div className="min-w-0">
                  <span className="text-[11px] font-semibold uppercase tracking-wide text-primary">{LABELS[resource]}</span>
                  <h3 className="font-semibold text-foreground leading-tight line-clamp-1">{title(resource, item)}</h3>
                  <p className="text-xs text-muted-foreground line-clamp-1">{item.description || item.summary || item.category || ""}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </SiteLayout>
  );
};

export default SearchPage;
